<template>
  <div class="py-3" style="background:#fff">
    <div class="d-flex justify-content-between align-items-center pb-3 px-5" style="border-bottom:1px solid #D6D5D5">
      <p class="mb-0" style="font-size:16px;font-weight:500;">Chi tiết tác vụ</p>
      <div class="d-flex gap-3">
        <el-tooltip :disabled="!enableCancelButton" class="item" effect="dark" content="Chưa tới thời gian hủy ca quy định" placement="top">
          <button type="button" class="btn btn-danger mr-4" :disabled="enableCancelButton" @click="openCancelModal">
            <i class="el-icon-circle-close"></i> Hủy ca
          </button>
        </el-tooltip>
        <button v-if="isSupplementTutor && +taskDetail.status === 0" type="button" class="btn btn-primary mr-4" @click="openCompleteModal('complete')">
          <i class="el-icon-circle-check"></i> Hoàn thành
        </button>
        <button v-if="isSupplementTutor && +taskDetail.status === NeedEvaluationStatus" type="button" class="btn btn-primary mr-4" @click="openReviewModal">
          <i class="el-icon-star-on"></i> Đánh giá buổi học
        </button>
        <button v-if="isSupplementTutor && +taskDetail.status === 1" type="button" class="btn btn-primary mr-4" @click="openReviewModal">
          <i class="el-icon-edit"></i> Sửa đánh giá
        </button>
        <el-tooltip v-if="!isSupplementTutor" :disabled="!enableCompleteButton" class="item" effect="dark" content="Chưa tới thời gian hủy ca quy định" placement="top">
          <button type="button" class="btn btn-primary mr-4" :disabled="enableCompleteButton" @click="openCompleteModal">
            <i class="el-icon-circle-check"></i> Hoàn thành
          </button>
        </el-tooltip>
        <button type="button" class="btn btn-success" :disabled="enableJoinButton" @click="openJoinModal">
          <i class="el-icon-s-platform"></i> Vào dạy
        </button>
      </div>
    </div>

    <div class="px-5 pt-3 row" v-loading="loading">
      <div class="col-md-6 px-6">
        <p class="px-2">Thông tin tác vụ</p>
        <CapacityTutor v-if="+taskDetail.type === 7" :task-detail="taskDetail" />
        <SupplementTutorDetail v-if="Number(tutorType) === 8" :task-detail="taskDetail" @open-students="openCompleteModal('view')" />
        <SpecialTutorDetail v-if="tutorType === TUTOR_TYPE.SpecialTutor" :task="task"></SpecialTutorDetail>
        <OpeningTutorDetail v-if="tutorType === TUTOR_TYPE.PostOpeningTutor" :task="task"></OpeningTutorDetail>
        <BufferTutorDetail v-if="tutorType === TUTOR_TYPE.BufferClassTutor" :task="task"></BufferTutorDetail>
        <MilitaryDetail v-if="[TUTOR_TYPE.MilitaryTutor, TUTOR_TYPE.PolicyTutor].includes(tutorType)" :task="task"></MilitaryDetail>
        <RetestTutorDetail v-if="tutorType === TUTOR_TYPE.RetestTutor" :task="task"></RetestTutorDetail>
        <div class="col-md-12 mt-6">
          <div style="display: flex; flex-direction: column; margin-top: 10px; margin-left: -4px">
            <label>Trạng thái tác vụ</label>
            <span style="padding: 4px 8px; border-radius: 4px; width: fit-content" :class="getClassStatus(taskDetail.status)">
              {{ getStatusLabel(taskDetail.status) }}
            </span>
          </div>
          <p class="mt-4" style="margin-left: -4px;" v-if="+task.status === 2">
            Lý do hủy ca: {{ `${task?.reason_cancel ?? 'Không có lý do'}` }}
          </p>
        </div>
      </div>
      <div class="col-md-6 px-6">
        <p style="margin-left: -10px">Kết quả công việc</p>
        <div style="border:1px solid #D6D5D5; border-radius: 5px;background-color: #F6F6F6" class="px-3 py-5 row">
          <div class="col-md-6 mb-4">
            <p>Nhân sự vào dạy</p>
            <el-input placeholder="-" :value="workResults?.admin_join_name"></el-input>
          </div>
          <div class="col-md-6 mb-4">
            <p>Thời gian vào dạy</p>
            <el-input placeholder="-" :value="formatDateTime(workResults?.admin_joined_at)"></el-input>
          </div>
          <div class="col-md-6 mb-4">
            <p>Công cụ dạy học</p>
            <el-input placeholder="-" :value="workResults?.tool"></el-input>
          </div>
          <div class="col-md-6 mb-4">
            <p>Nhân sự check-in</p>
            <el-input placeholder="-" :value="workResults?.admin_checkin"></el-input>
          </div>
          <div class="col-md-6 mb-4">
            <p>Thời gian check-in</p>
            <el-input placeholder="-" :value="formatDateTime(workResults?.admin_checkin_at)"></el-input>
          </div>
          <div class="col-md-6 mb-4">
            <p>Ảnh check-in</p>
            <el-image
              v-if="workResults?.link_checkin"
              style="width: 100px; height: 100px"
              fit="cover"
              :src="workResults?.link_checkin"
              :preview-src-list="[workResults?.link_checkin]"
            >
            </el-image>
          </div>
          <div v-if="isSupplementTutor" class="col-md-6 mb-4">
            <p>Kết quả điểm danh</p>
            <div style="position: relative">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="-"
                :value="attendanceSummaryLabel"
              />
              <button v-if="hasAttendance" type="button" class="detail-link" @click="openAttendanceModal">Xem chi tiết</button>
            </div>
          </div>
          <div v-if="isSupplementTutor" class="col-md-6 mb-4">
            <p>Kết quả bổ trợ năng lực</p>
            <div style="position: relative">
               <el-input
                type="textarea"
                :rows="3"
                placeholder="-"
                :value="supplementResultLabel"/>
              <button type="button" class="detail-link" @click="openReviewModal">Xem chi tiết</button>
            </div>
          </div>
          <div v-if="isSupplementTutor" class="col-md-6 mb-4">
            <p>Đánh giá buổi học</p>
            <el-input placeholder="-" :value="reviewStatusLabel"></el-input>
          </div>
          <div v-if="!isSupplementTutor" class="col-md-6 mb-4">
            <p>Đánh giá sao</p>
            <el-input placeholder="-" :value="workResults?.rating"></el-input>
          </div>
          <div v-if="!isSupplementTutor" class="col-md-12 mb-4">
            <p>Nội dung Feedback</p>
            <div class="feedback-contents">
              <div class="content">
                <p v-for="item in workResults?.feedbacks" :key="item" class="feedback">{{ item }}</p>
              </div>
              <div v-if="workResults?.feedback_note" class="mt-5">
                <p>Chi tiết: {{ workResults?.feedback_note }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CancelModal @loadDetail="fetchTask"></CancelModal>
    <CompleteModal :type-task="isSupplementTutor ? 8 : taskDetail.type" :task="task" :mode="completeModalMode" :supplementary-students="supplementaryStudents" @loadDetail="fetchTask"></CompleteModal>
    <SupplementTutorReviewModal :task="task" :supplementary-students="supplementaryStudents" :supplementary-students-loaded="supplementaryStudentsLoaded" @loadDetail="fetchTask"></SupplementTutorReviewModal>
    <JoinClassModal :task="task" @loadDetail="fetchTask"></JoinClassModal>
  </div>
</template>

<script>
import SpecialTutorDetail from "@/view/pages/tutor/task-management/task-detail/SpecialTutorDetail.vue";
import { GET_SUPPLEMENTARY_TUTOR_STUDENTS, GET_TUTOR_DETAIL_TASK } from "@/core/services/store/tutor/tutor.module";
import { TutorType } from "@/core/option/tutorOption";
import OpeningTutorDetail from "@/view/pages/tutor/task-management/task-detail/OpeningTutorDetail.vue";
import MilitaryDetail from "@/view/pages/tutor/task-management/task-detail/MilitaryDetail.vue";
import BufferTutorDetail from "@/view/pages/tutor/task-management/task-detail/BufferTutorDetail.vue";
import moment from "moment-timezone";
import CancelModal from "@/view/pages/tutor/task-management/task-detail/CancelModal.vue";
import CompleteModal from "@/view/pages/tutor/task-management/task-detail/CompleteModal.vue";
import JoinClassModal from "@/view/pages/tutor/task-management/task-detail/JoinClassModal.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import RetestTutorDetail from "./RetestTutorDetail.vue";
import CapacityTutor from "./CapacityTutor.vue";
import SupplementTutorDetail from "./SupplementTutorDetail.vue";
import { getSupplementTutorMockTaskById } from "@/core/mock/tutorSupplement.mock";
import SupplementTutorReviewModal from "./SupplementTutorReviewModal.vue";
import { Attendance, NeedEvaluationStatus } from "../../../../../core/option/tutorOption.js";

export default {
  name: 'TaskDetail',
  components: {
    CapacityTutor,
    SupplementTutorDetail,
    RetestTutorDetail,
    JoinClassModal,
    CompleteModal,
    CancelModal,
    BufferTutorDetail,
    MilitaryDetail,
    OpeningTutorDetail,
    SpecialTutorDetail,
    SupplementTutorReviewModal
  },
  data() {
    return {
      loading: false,
      checkingIn: false,
      task: {},
      tutorType: null,
      TUTOR_TYPE: TutorType,
      workResults: {},
      taskDetail: {},
      busy: false,
      completeModalMode: 'complete',
      supplementaryStudents: [],
      supplementaryStudentsLoaded: false,
      NeedEvaluationStatus
    };
  },
  created() {
    this.fetchTask();
    const breadcrumb = this.$route.query.type;
    if (breadcrumb === 'personal') {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Tác vụ cá nhân", route: 'tutor-personal-task' },
        { title: "Chi tiết tác vụ" }
      ]);
    } else {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Quản lý tác vụ", route: 'task-management' },
        { title: "Chi tiết tác vụ" }
      ]);
    }
  },
  methods: {
    async fetchTask() {
      try {
        this.loading = true;
        const idTask = this.$route.params.id;

        if (String(idTask).startsWith('SUP-')) {
          const mockTask = getSupplementTutorMockTaskById(idTask);
          if (mockTask) {
            this.taskDetail = {
              ...mockTask.detail,
              id: mockTask.id,
              name: mockTask.user_name,
              phone: mockTask.user_phone,
              level: mockTask.level_out_name,
              userId: mockTask.user_id,
              best_customer_id: mockTask.best_customer_id,
              status: mockTask.status
            };
            this.task = mockTask;
            this.tutorType = mockTask.subtype;
            this.workResults = mockTask.work_results;
            this.supplementaryStudents = mockTask.supplement_students || mockTask.detail?.students || [];
            return;
          }
        }

        const res = await this.$store.dispatch(GET_TUTOR_DETAIL_TASK, idTask);
        this.taskDetail = {
          ...res.data.detail,
          id: res.data?.id,
          name: res.data?.user_name,
          phone: res.data?.user_phone,
          level: res.data?.level_out_name,
          userId: res.data?.user_id,
          best_customer_id: res.data?.best_customer_id,
          status: res.data.status
        };
        this.task = res?.data;
        this.tutorType = res?.data?.subtype;
        this.workResults = res?.data?.work_results;
        if (Number(this.tutorType) === 8) {
          try {
            const studentsRes = await this.$store.dispatch(GET_SUPPLEMENTARY_TUTOR_STUDENTS, idTask);
            this.supplementaryStudents = studentsRes?.data?.students || [];
          } catch (e) {
            this.supplementaryStudents = [];
          }
        }
      } finally {
        this.loading = false;
      }
    },
    openCancelModal() {
      this.$bvModal.show('cancel-modal');
    },
    async openCompleteModal(mode = 'complete') {
      this.completeModalMode = mode;
      if (this.isSupplementTutor && !String(this.$route.params.id).startsWith('SUP-')) {
        try {
          const res = await this.$store.dispatch(GET_SUPPLEMENTARY_TUTOR_STUDENTS, this.$route.params.id);
          this.supplementaryStudents = res?.data?.students || [];
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Không thể tải danh sách học viên'
          });
          return;
        }
      }
     await this.$nextTick();
      this.$bvModal.show('complete-modal');
    },
    async openAttendanceModal() {
      this.completeModalMode = 'attendance';
      if (!await this.loadSupplementaryStudents()) {
        return;
      }
      await this.$nextTick();
      this.$bvModal.show('complete-modal');
    },
    async loadSupplementaryStudents() {
      if (!String(this.$route.params.id).startsWith('SUP-')) {
        try {
          const res = await this.$store.dispatch(GET_SUPPLEMENTARY_TUTOR_STUDENTS, this.$route.params.id);
          this.supplementaryStudents = res?.data?.students || [];
        } catch (e) {
          this.$notify.error({
            title: 'Lỗi',
            message: 'Không thể tải danh sách học viên'
          });
          return false;
        }
      } else {
        this.supplementaryStudents = this.task?.supplement_students || this.task?.detail?.students || [];
      }
      return true;
    },
    async openReviewModal() {
      if (this.isSupplementTutor && !String(this.$route.params.id).startsWith('SUP-')) {
        try {
          const res = await this.$store.dispatch(GET_SUPPLEMENTARY_TUTOR_STUDENTS, this.$route.params.id);
          this.supplementaryStudents = (res?.data?.students || []).filter((student) => Number(student.attendance_status) === 1);
          this.supplementaryStudentsLoaded = true;
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Không thể tải danh sách học viên'
          });
          return;
        }
      }
       await this.$nextTick();
      this.$bvModal.show('supplement-review-modal');
    },
    openJoinModal() {
      this.$bvModal.show('join-class-modal');
    },
    formatDateTime(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY HH:mm:ss');
      }
      return '-';
    },
    getStatusLabel(val) {
      switch (val) {
        case 0:
          return 'Cần làm';
        case 1: 
          return 'Hoàn thành';
        case 2:
          return 'Hủy';
        case 3:
          return 'Cần chấm BTVN';
        case 4:
          return 'Hoàn thành buổi học';
        case 5: case 6:
          return 'Cần đánh giá';
        default:
          return '';
      }
    },
    getClassStatus(status) {
      switch (status) {
        case 0:
          return 'bg-status-wait';
        case 1: 
          return 'bg-status-success';
        case 2:
          return 'bg-status-cancel';
        case 3:
          return 'bg-status-need';
        case 4:
          return 'bg-status-success-hw';
        case 5: case 6:
          return 'bg-status-need-review';
        default:
          return '';
      }
    }
  },
  computed: {
    isSupplementTutor() {
      return Number(this.tutorType) === 8 || Number(this.task?.subtype) === 8;
    },
    attendanceRows() {
      return this.supplementaryStudents.length
        ? this.supplementaryStudents
        : (this.task?.supplement_students || this.task?.detail?.students || []);
    },
    hasAttendance() {
      const status = this.workResults?.attendance_status || this.task?.attendance_status;
      return +status === Attendance || this.attendanceRows.some((student) => student.attendance_status !== null && student.attendance_status !== undefined);
    },
    attendanceSummaryLabel() {
      if (!this.hasAttendance) {
        return '';
      }

      const present = this.attendanceRows.filter((student) => Number(student.attendance_status || student.status) === 1).length;
      const absent = this.attendanceRows.filter((student) => Number(student.attendance_status || student.status) === 2).length;
      return `${present} học viên Có mặt;\n${absent} học viên Vắng`;
    },
    supplementResultLabel() {
      const summary = this.workResults?.evaluation_summary || this.task?.supplement_result;
      const reviews = this.workResults?.supplement_reviews || this.task?.supplement_reviews || [];
      const passed = summary?.passed ?? reviews.filter((item) => item.result === 'passed').length;
      const failed = summary?.failed ?? reviews.filter((item) => item.result === 'failed').length;
      const noHomework = summary?.no_submit ?? reviews.filter((item) => item.result === 'no_homework').length;

      if (!passed && !failed && !noHomework) {
        return '-';
      }

     return `${passed} học viên Đạt;\n${failed} học viên không Đạt;\n${noHomework} học viên không làm bài tập`;
    },
    reviewStatusLabel() {
      if (+this.taskDetail.status === 1) {
        return 'Đã đánh giá';
      }

      if (+this.taskDetail.status === 5) {
        return 'Cần đánh giá';
      }

      return '-';
    },
    enableCancelButton() {
      const cancelButton = this.task?.action_buttons?.find((button) => button.name === 'cancel');
      if (!cancelButton) return true;
      const now = moment();
      return now.isBefore(cancelButton?.enable_at);
    },
    enableCompleteButton() {
      const completeButton = this.task?.action_buttons?.find((button) => button.name === 'complete');
      if (!completeButton) return true;
      const now = moment();
      return now.isBefore(completeButton?.enable_at);
    },
    enableJoinButton() {
      return this.task?.status === 2;
    }
  }
};
</script>

<style scoped>
.feedback-contents {
  width: 100%;
  min-height: 150px;
  border: 1px solid #D6D5D5;
  background-color: white;
  padding: 10px;
}

.feedback {
  background-color: #e6e6e6;
  padding: 5px;
  border-radius: 5px;
}

.content {
  padding: 0 !important;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.detail-link {
  border: none;
  background: transparent;
  color: #0066FF;
  position: absolute;
  top: 80%;
  right: 8px;
  transform: translateY(-50%);
  padding: 0;
}

.bg-status-success {
  background: #1BC5BD;
  color: white;
}

.bg-status-need {
  background: #7000FF;
  color: white;
}

.bg-status-wait {
  background: #FFC424;
  color: black;
}

.bg-status-success-hw {
  background: #0A51BC;
  color: white;
}

.bg-status-cancel {
  background: #575757CC;
  color: white;
}

.bg-status-need-review {
  background: #FF8A00;
  color: white;
}
</style>
